// src/config/clerk.ts
export const getClerkEnv = () =>
  (import.meta.env.VITE_USE_CLERK_ENV || 'dev').toLowerCase();

export function resolveClerkPublishableKey(): string {
  const env = getClerkEnv();
  const dev = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_DEV;
  const prod = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_PROD;
  const fallback = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY; // Fallback to old env var
  
  // CB:BEGIN environment-matching-fix  
  // Use environment variable or fallback
  const resolvedKey = dev || prod || fallback;
  
  console.log('[ClerkResolver] Debug:', {
    env,
    hasDev: !!dev,
    hasProd: !!prod,
    hasFallback: !!fallback,
    resolvedKeyPrefix: resolvedKey?.slice(0, 12),
    devPrefix: dev?.slice(0, 12),
    prodPrefix: prod?.slice(0, 12),
    fallbackPrefix: fallback?.slice(0, 12)
  });
  
  if (!resolvedKey) {
    throw new Error('No Clerk publishable key found in environment variables');
  }
  
  // Use the environment variable key
  return resolvedKey;
  // CB:END environment-matching-fix
}

// Runtime validation
export function logClerkEnv() {
  console.info('[ClerkEnv]', {
    FE_ENV: getClerkEnv(),
    PK: resolveClerkPublishableKey()?.slice(0, 12) + '…'
  });
}
